export const ukShoeSizes = () => {
  const result: number[] = []

  for (let size = 2; size < 16; size = size + 0.5) {
    result.push(size)
  }

  return result
}

// TODO: this needs to be updated, since it does not cover all the EU sizes for all brands
export const euShoeSizes = () => {
  const result: number[] = []

  for (let size = 15; size < 54; size = size + 0.5) {
    result.push(size)
  }

  return result
}
